// Furnio rate engine — ported verbatim from furnio-quote/src/App.jsx calculation logic.
// Exposed as window.FurnioEngine (plain script, no ES module) so it can be loaded
// with a normal <script src> tag alongside the rest of the theme's JS.
(function (window) {
  "use strict";

  var DEFAULT_RATES = {
    margin: 0.40,
    ply16mm_sft: 81, ply6mm_sft: 58.3, liner_sheet: 488, visible_lam_sheet: 488,
    pressing_sheet: 250, edgeband_invisible: 10, edgeband_visible: 17,
    wastage_carcass: 0.15, wastage_shutter: 0.25, wastage_carcass_panel: 0.20,
    hdhmr16mm_sft: 86, shutter_outer_lam: 2500, shutter_inner_lam: 488,
    shutter_pressing: 250, shutter_edgeband_visible: 17, profile_shutter_sft: 1000,
    hinge_cost: 275, straightener_cost: 1064, dust_strip_cost: 525, handle_cost: 1200,
    handle_pto_cost: 85, connector_cost: 10, leveller_cost: 14.1, leg_cost: 41.25,
    skirting_cost_rft: 163, wall_hanging_cost: 404, hanger_rod_cost_1m: 625,
    channel_cost: 1123, tandem_hw_cost: 4400, lighting_cost_rft: 400, installation_sft: 163,
    drawer_clearance: 20, drawer_plank_thickness: 16, drawer_bottom_thickness: 9,
    bed_minifix_cost: 94.4, bed_hole_cost: 4, bed_install_sft: 130,
    bed_liftup_cost: 3388.16, bed_12mm_sft: 85.28,
    cutting_rate: 1.044, grooving_rate: 6, minifix_rate: 7.66, hole_rate: 1.75,
    packing_rate: 5, panel_thickness: 18, back_ply_thickness: 9, edgeband_thickness: 1,
    premilling: 0.5, groove_depth: 8,
  };

  var SHUTTER_INDEX = [
    { name: "Profile Shutter", key: "profile_shutter", delta: null },
    { name: "PU", key: "pu", rate: 800 },
    { name: "Fluted", key: "fluted", rate: 1500 },
    { name: "Open", key: "open", delta: "negative_base" },
    { name: "Veneer", key: "veneer", rate: 1000 },
    { name: "Acrylic", key: "acrylic", rate: 1019.08 },
    { name: "Glass", key: "glass", rate: 1538.46 },
    { name: "Internal", key: "internal", delta: "negative_panel" },
    { name: "Rattan Cane", key: "rattan", rate: 900 },
    { name: "Paneling", key: "paneling", rate: 800 },
    { name: "Fenix", key: "fenix", rate: 700 },
    { name: "Technomatt", key: "technomatt", rate: 673 },
    { name: "GM", key: "gm", rate: 550 },
    { name: "Thermo", key: "thermo", rate: 560 },
    { name: "Design", key: "design", rate: 1000 },
    { name: "Metallic", key: "metallic", rate: 1500 },
    { name: "Leather", key: "leather", rate: 2000 },
    { name: "PP", key: "pp", rate: 2500 },
    { name: "Deseo", key: "deseo", rate: 5000 },
    { name: "Premium", key: "premium", rate: 1200 },
    { name: "Mirror", key: "mirror", deltaFixed: 300 },
    { name: "CNC", key: "cnc", deltaFormula: "base_plus_100" },
  ];

  var ACCESSORIES = [
    { name: "Lock", price: 581.54 }, { name: "Rolling Shutter", price: 38461.54 },
    { name: "SS Legs 100mm", price: 769.23 }, { name: "BPO", price: 9803.51 },
    { name: "Cutlery Tray", price: 2087.38 }, { name: "Plate Rack", price: 3547.94 },
    { name: "Inset Sliding", price: 5500 }, { name: "Overlay Sliding", price: 20254 },
    { name: "Wicker Basket", price: 8736 }, { name: "Lemans Corner", price: 18407 },
    { name: "Lift Up", price: 650 }, { name: "Dust Bin", price: 9599 },
    { name: "Trouser Pullout", price: 10099 }, { name: "Saree Pullout", price: 10099 },
    { name: "Magic Corner", price: 29995 }, { name: "Pantry", price: 32037 },
    { name: "Folding Table", price: 3000 }, { name: "Ventilation Grill", price: 426 },
    { name: "Detergent Holder", price: 2312 }, { name: "Yale Digital Lock", price: 4720 },
    { name: "Combination Lock", price: 1050 }, { name: "Biometric Lock", price: 3740 },
    { name: "Wine Glass Holder", price: 2000 }, { name: "Laundry Bin Tilt", price: 9356 },
    { name: "Internal Dividers", price: 6180 }, { name: "Pull Down", price: 12500 },
    { name: "Cupboard Pullout", price: 15470 }, { name: "Wardrobe Pullout Shoe Rack", price: 10862 },
    { name: "Murphy Bed", price: 32363 },
  ];

  function getDerived(r) {
    var ply16 = r.ply16mm_sft * 0.8;
    var ply6 = r.ply6mm_sft * 0.8;
    var liner = r.liner_sheet * 0.8;
    var visLam = r.visible_lam_sheet * 0.8;
    var press = r.pressing_sheet * 0.8;
    var ebInv = r.edgeband_invisible * 0.8;
    var ebVis = r.edgeband_visible * 0.8;
    var hinge = r.hinge_cost * 0.8;
    var straightener = r.straightener_cost * 0.8;
    var dustStrip = r.dust_strip_cost * 0.8;
    var handle = r.handle_cost * 0.8;
    var handlePto = r.handle_pto_cost * 0.8;
    var leveller = r.leveller_cost * 0.8;
    var leg = r.leg_cost * 0.8;
    var skirting = r.skirting_cost_rft * 0.8;
    var wallHang = r.wall_hanging_cost * 0.8;
    var hangerRod = r.hanger_rod_cost_1m * 0.8;
    var channel = r.channel_cost * 0.8;
    var tandemHw = r.tandem_hw_cost * 0.8;
    var install = r.installation_sft * 0.8;
    var shutterEB = r.shutter_edgeband_visible * 0.8;
    var shutterCore = (r.hdhmr16mm_sft + r.shutter_outer_lam / 32 + r.shutter_inner_lam / 32) * 0.8;
    var shutterPress = r.shutter_pressing * 0.8 / 32;
    return {
      ply16: ply16, ply6: ply6, liner: liner, visLam: visLam, press: press, ebInv: ebInv, ebVis: ebVis,
      hinge: hinge, straightener: straightener, dustStrip: dustStrip, handle: handle, handlePto: handlePto,
      leveller: leveller, leg: leg, skirting: skirting, wallHang: wallHang, hangerRod: hangerRod,
      channel: channel, tandemHw: tandemHw, install: install,
      shutterEB: shutterEB, shutterCore: shutterCore, shutterPress: shutterPress,
      connector: r.connector_cost, lighting: r.lighting_cost_rft,
    };
  }

  function calcShutterSftRate(r, d) {
    var W = 600, H = 720, Q = 1;
    var wastage = r.wastage_shutter;
    var perim = (2 * (W + H) * Q) / 300;
    var cutting = perim * r.cutting_rate;
    var ebVis = perim * d.shutterEB;
    var area = (W * H * Q) / 92903 / (1 - wastage);
    var coreLam = area * d.shutterCore;
    var pressing = area * d.shutterPress;
    var packing = area * r.packing_rate;
    var total = cutting + ebVis + coreLam + pressing + packing;
    return total / (W * H * Q / 92903);
  }

  function calcCarcassPanelSftRate(r, d) {
    var W = 600, H = 720, Q = 1;
    var wastage = r.wastage_carcass_panel;
    var perim = (2 * (W + H) * Q) / 300;
    var cutting = perim * r.cutting_rate;
    var ebInvPerim = perim - (H * Q / 300);
    var ebInv = ebInvPerim * d.ebInv;
    var ebVisPerim = H * Q / 300;
    var ebVis = ebVisPerim * d.ebVis;
    var area = (W * H * Q) / 92903 / (1 - wastage);
    var coreLamRate = (d.ply16 + d.liner / 32 * 2) * 1;
    var coreLam = area * coreLamRate;
    var pressing = area * (d.press / 32);
    var packing = area * r.packing_rate;
    var total = cutting + ebInv + ebVis + coreLam + pressing + packing;
    return total / (W * H * Q / 92903);
  }

  function getShutterDelta(r, shutterType) {
    var d = getDerived(r);
    var shutterSftRate = calcShutterSftRate(r, d);
    var baseSftWithMargin = shutterSftRate / (1 - r.margin);
    var panelSftRate = calcCarcassPanelSftRate(r, d);
    var panelWithMargin = panelSftRate / (1 - r.margin);
    var lower = shutterType.toLowerCase();
    var si = null, i;
    for (i = 0; i < SHUTTER_INDEX.length; i++) { if (lower.indexOf(SHUTTER_INDEX[i].key) !== -1) { si = SHUTTER_INDEX[i]; break; } }
    if (!si) { for (i = 0; i < SHUTTER_INDEX.length; i++) { if (lower.indexOf(SHUTTER_INDEX[i].name.toLowerCase()) !== -1) { si = SHUTTER_INDEX[i]; break; } } }
    if (!si) return 0;
    if (si.key === "open") return -baseSftWithMargin;
    if (si.key === "internal") return -panelWithMargin;
    if (si.key === "profile_shutter") return (r.profile_shutter_sft - baseSftWithMargin);
    if (si.deltaFixed !== undefined) return si.deltaFixed;
    if (si.deltaFormula === "base_plus_100") return baseSftWithMargin + 100;
    if (si.rate !== undefined) return si.rate - baseSftWithMargin;
    if (si.delta !== undefined) return si.delta;
    return 0;
  }

  function calcCabinet(r, W, H, D, qty, options) {
    options = options || {};
    var d = getDerived(r);
    var ET = r.edgeband_thickness;
    var PT = r.panel_thickness;
    var PM = r.premilling;
    var GD = r.groove_depth;
    var wastage = r.wastage_carcass;

    var visVertL = H - 2 * ET;
    var visVertW = D - 2 * ET - PM;
    var leftVertL = visVertL;
    var leftVertW = visVertW;
    var topL = W - 2 * PT - 2 * ET;
    var topW = leftVertW;
    var botL = topL;
    var botW = D - 2 * ET - PM;
    var backL = H - 2 * PT + 2 * GD;
    var backW = W - 2 * PT + 2 * GD;

    var cuttingRft = ((2 * (visVertL + visVertW)) + (2 * (leftVertL + leftVertW)) + (2 * (topL + topW)) + (2 * (botL + botW)) + (2 * (backL + backW))) / 304;
    var groovingRft = (2 * (backL + backW)) / 304;
    var ebVisRft = (visVertL + leftVertL + topL + botL) / 304;
    var ebInvRft = cuttingRft - groovingRft - ebVisRft;
    var minifixQty = 1 * 12;
    var holesQty = minifixQty * 5;

    var nonVisArea = ((leftVertL * leftVertW) + (topL * topW) + (botL * botW)) / 92903 / (1 - wastage);
    var visArea = (visVertL * visVertW) / 92903 / (1 - wastage);
    var backArea = (backL * backW) / 92903 / (1 - wastage);

    var cutting = cuttingRft * r.cutting_rate;
    var ebInv = ebInvRft * d.ebInv;
    var ebVis = ebVisRft * d.ebVis;
    var grooving = groovingRft * r.grooving_rate;
    var minifix = minifixQty * r.minifix_rate;
    var holes = holesQty * r.hole_rate;
    var core = nonVisArea * d.ply16;
    var lam = nonVisArea * (d.liner / 32 * 2);
    var visCore = visArea * (d.ply16 + d.liner / 32);
    var visLam = visArea * (d.visLam / 32);
    var backCore = backArea * d.ply6;
    var backLam = backArea * (d.liner / 32 * 2);
    var totalSft = nonVisArea + visArea + backArea;
    var pressing = totalSft * (d.press / 32);
    var packing = totalSft * r.packing_rate;

    var cabinetCost = cutting + ebInv + ebVis + grooving + minifix + holes + core + lam + visCore + visLam + backCore + backLam + pressing + packing;

    var shutterSftRate = calcShutterSftRate(r, d);
    var shutterCost = shutterSftRate * W * H / 92903;

    var hingeCount = (W > 600 ? 2 : 1) * (H < 750 ? 2 : H < 1500 ? 3 : H < 2300 ? 4 : H < 2700 ? 5 : 6) * 0.5;
    var hingeCost = hingeCount * d.hinge;

    var connCost = 4 * d.connector;
    var levCost = (options.levellers || 0) * d.leveller;
    var legCost = (options.legs || 0) * d.leg;
    var skirtCost = options.hasSkirting ? (W / 300 * d.skirting) : 0;
    var wallHangCost = (options.wallHanging || 0) * d.wallHang;
    var hangerCost = (options.hangerRods || 0) * d.hangerRod;
    var straightCount = (W > 600 ? 2 : 1) * (H > 2100 ? 1 : 0);
    var straightCost = straightCount * d.straightener;
    var dustCount = H > 1500 ? 1 : 0;
    var dustCost = dustCount * d.dustStrip;
    var handleCount = W > 600 ? 2 : 1;
    var handleCost = handleCount * d.handle;
    var lightCost = (options.lightingMm || 0) / 300 * d.lighting;
    var installCost = d.install * W * H / 92903;

    var total = cabinetCost + shutterCost + hingeCost + connCost + levCost + legCost + skirtCost + wallHangCost + hangerCost + straightCost + dustCost + handleCost + lightCost + installCost;
    var price = total / (1 - r.margin) * qty;
    var sft = (W * H * qty) / 90000;

    return { price: price, sft: sft, total: total, cabinetCost: cabinetCost, shutterCost: shutterCost, shutterSftRate: shutterSftRate };
  }

  function calcFrame(r, W, H, D, qty) {
    var d = getDerived(r);
    var ET = r.edgeband_thickness;
    var PT = r.panel_thickness;
    var PM = r.premilling;
    var wastage = r.wastage_carcass;

    var visVertL = H - 2 * ET;
    var visVertW = D - 2 * ET - PM;
    var leftVertL = visVertL;
    var leftVertW = visVertW;
    var topL = W - 2 * PT - 2 * ET;
    var topW = leftVertW;
    var botL = topL;
    var botW = D - 2 * ET - PM;

    var cuttingRft = ((2 * (visVertL + visVertW)) + (2 * (leftVertL + leftVertW)) + (2 * (topL + topW)) + (2 * (botL + botW))) / 304;
    var ebVisRft = (visVertL + leftVertL + topL + botL) / 304;
    var ebInvRft = cuttingRft - ebVisRft;
    var minifixQty = 1 * 8;

    var nonVisArea = ((leftVertL * leftVertW) + (topL * topW) + (botL * botW)) / 92903 / (1 - wastage);
    var visArea = (visVertL * visVertW) / 92903 / (1 - wastage);

    var cutting = cuttingRft * r.cutting_rate;
    var ebInv = ebInvRft * d.ebInv;
    var ebVis = ebVisRft * d.ebVis;
    var minifix = minifixQty * 0.8;
    var core = nonVisArea * d.ply16;
    var lam = nonVisArea * (d.liner / 32 * 2);
    var visCore = visArea * (d.ply16 + d.liner / 32);
    var visLamCost = visArea * (d.visLam / 32);
    var totalSft = nonVisArea + visArea;
    var pressing = totalSft * (d.press / 32);
    var packing = totalSft * r.packing_rate;

    var frameCost = cutting + ebInv + ebVis + minifix + core + lam + visCore + visLamCost + pressing + packing;

    var shutterSftRate = calcShutterSftRate(r, d);
    var shutterCost = shutterSftRate * W * H / 92903;

    var hingeCount = (W > 600 ? 2 : 1) * (H < 750 ? 2 : H < 1500 ? 3 : H < 2300 ? 4 : H < 2700 ? 5 : 6) * 0.5;
    var hingeCost = hingeCount * d.hinge;
    var connCost = 4 * d.connector;
    var straightCount = (W > 600 ? 2 : 1) * (H > 2100 ? 1 : 0);
    var straightCost = straightCount * d.straightener;
    var dustCost = (H / 2400 / 0.8) * d.dustStrip;
    var handleCount = W > 600 ? 2 : 1;
    var handleCost = handleCount * (r.handle_pto_cost * 0.8);
    var installRate = d.install + 70;
    var installCost = installRate * W * H / 92903;

    var total = frameCost + shutterCost + hingeCost + connCost + straightCost + dustCost + handleCost + installCost;
    var price = total / (1 - r.margin) * qty;
    var sft = (W * H * qty) / 90000;
    return { price: price, sft: sft };
  }

  function calcShelf(r, W, D, qty) {
    var d = getDerived(r);
    var wastage = r.wastage_carcass;
    var cuttingRft = (2 * (W + D) * qty) / 300;
    var cutting = cuttingRft * r.cutting_rate;
    var ebVisRft = W / 300 * qty;
    var ebInvRft = cuttingRft - ebVisRft;
    var ebInv = ebInvRft * d.ebInv;
    var ebVis = ebVisRft * d.ebVis;
    var minifixQty = 4 * qty;
    var minifix = minifixQty * r.minifix_rate;
    var holesQty = minifixQty * 5;
    var holes = holesQty * r.hole_rate;
    var area = (W * D * qty) / 92903 / (1 - wastage);
    var coreLam = area * (d.ply16 + d.liner / 32 * 2);
    var pressing = area * (d.press / 32);
    var packing = area * r.packing_rate;
    var total = cutting + ebInv + ebVis + minifix + holes + coreLam + pressing + packing;
    var price = total / (1 - r.margin);
    return { price: price };
  }

  function calcLedge(r, W, D, qty) {
    var d = getDerived(r);
    var wastage = r.wastage_carcass;
    var premLam = r.shutter_outer_lam * 0.8;
    var cuttingRft = (2 * (W + D) * qty) / 300;
    var cutting = cuttingRft * r.cutting_rate;
    var ebVis = cuttingRft * d.ebVis;
    var rodCount;
    if (W < 600) rodCount = 2;
    else if (W < 900) rodCount = 3;
    else if (W < 1200) rodCount = 4;
    else if (W < 1500) rodCount = 5;
    else if (W < 1800) rodCount = 6;
    else rodCount = Math.ceil((W - 600) / 300) + 2;
    var rodCost = rodCount * qty * 95;
    var holesQty = rodCount * qty * 5;
    var holes = holesQty * r.hole_rate;
    var area = (W * D * qty) / 92903 / (1 - wastage);
    var coreLam = area * (d.ply16 + premLam / 32 * 2);
    var pressing = area * (d.press / 32);
    var packing = area * r.packing_rate;
    var total = cutting + ebVis + rodCost + holes + coreLam + pressing + packing;
    var price = total / (1 - r.margin);
    return { price: price };
  }

  function calcDrawer(r, faciaW, faciaH, depth, qty) {
    var d = getDerived(r);
    var wastage = r.wastage_carcass;
    var ET = r.edgeband_thickness;
    var GT = 16;
    var GD = 8;
    var clearance = 20;
    var fillerW = 20;
    var faceH = faciaH - clearance;

    var faciaL = faciaW - 2 * ET;
    var faciaWd = faciaH - 2 * ET;
    var sideL = depth - 2 * ET;
    var sideW = faceH - 2 * ET;
    var fbL = faciaW - 2 * GT - 6 * ET;
    var fbW = faceH - 2 * ET;
    var botL = depth - 2 * GT - 4 * ET + 2 * GD;
    var botW = faciaW - 2 * GT - 4 * ET + 2 * GD;
    var supL = sideL;
    var supW = faciaH;
    var fillL = faciaH;
    var fillW = fillerW;

    var cuttingRft = ((2 * (faciaL + faciaWd)) + (2 * (sideL + sideW) * 2) + (2 * (fbL + fbW) * 2) + (2 * (botL + botW)) + (2 * (supL + supW) * 2) + (2 * (fillL + fillW) * 2)) / 300;
    var cutting = cuttingRft * r.cutting_rate;
    var ebVisRft = (2 * (faciaL + faciaWd)) / 300;
    var ebInvRft = cuttingRft - ebVisRft;
    var groovingRft = (2 * (botL + botW)) / 300;
    var ebInv = (ebInvRft - groovingRft) * d.ebInv;
    var ebVis = ebVisRft * d.ebVis;
    var grooving = groovingRft * r.grooving_rate;
    var minifix = 8 * r.minifix_rate;
    var holes = 40 * r.hole_rate;
    var coreArea = ((faciaL * faciaWd) + (sideL * sideW * 2) + (fbL * fbW * 2) + (supL * supW * 2) + (fillL * fillW * 2)) / 92903 / (1 - wastage);
    var coreLam = coreArea * (d.ply16 + d.liner / 32 * 2);
    var backArea = (botL * botW) / 92903 / (1 - wastage);
    var backCoreLam = backArea * (d.ply6 + d.liner / 32 * 2);
    var totalSft = coreArea + backArea;
    var pressing = totalSft * (d.press / 32);
    var packing = coreArea * r.packing_rate;
    var channelCost = 1 * d.channel;

    var total = cutting + ebInv + ebVis + grooving + minifix + holes + coreLam + backCoreLam + pressing + packing + channelCost;
    var price = total / (1 - r.margin) * qty;
    return { price: price };
  }

  function calcTandem(r, W, H, D, qty) {
    var d = getDerived(r);
    var wastage = r.wastage_carcass;
    var backL = W, backW = H;
    var botL = D, botW = W;
    var cuttingRft = ((2 * (backL + backW)) + (2 * (botL + botW))) / 300;
    var cutting = cuttingRft * r.cutting_rate;
    var ebInvRft = 2 * backL / 300;
    var ebInv = ebInvRft * d.ebInv;
    var groovingRft = (2 * botL) / 304;
    var grooving = groovingRft * r.grooving_rate;
    var area = ((backL * backW) + (botL * botW)) / 92903 / (1 - wastage);
    var coreLam = area * (d.ply16 + 2 * d.liner / 32);
    var pressing = area * (d.press / 32);
    var packing = area * r.packing_rate;
    var hw = d.tandemHw;
    var total = cutting + ebInv + grooving + coreLam + pressing + packing + hw;
    var price = total / (1 - r.margin) * qty;
    return { price: price };
  }

  function calcBed(r, W, L, H, qty) {
    var PT = 18, ET = 1;
    var headFootL = W - 2 * ET;
    var headFootW = H;
    var headFootQty = qty * 2;
    var botL = (W - 3 * PT) / 2;
    var botW = L - 2 * PT;
    var botQty = qty * 2;
    var topL = W - 2 * PT - 4;
    var topW = L - 2 * PT - 4;
    var topQty = qty;
    var supL = L - 2 * ET - 2 * PT;
    var supW = H;
    var supQty = qty * 3;
    var stripL = L - 2 * ET - 2 * PT;
    var stripW = 50 - 2 * ET;
    var stripQty = qty * 8;
    var wStripL = (W - 2 * ET - 2 * PT) / 2;
    var wStripW = 50 - 2 * ET;
    var wStripQty = qty * 8;
    var floorL = wStripL;
    var floorW = wStripW;
    var floorQty = qty * 8;

    var shutterSftRate = calcShutterSftRate(r, getDerived(r));
    var sft18 = (headFootL * headFootW * headFootQty + stripL * stripW * stripQty + wStripL * wStripW * wStripQty + supL * supW * supQty + floorL * floorW * floorQty + topL * topW * topQty) / 92903;
    var cost18 = sft18 * shutterSftRate;
    var sft12 = (botL * botW * botQty) / 92903;
    var cost12 = sft12 * r.bed_12mm_sft;
    var minifixCost = 32 * qty * r.bed_minifix_cost;
    var holeCost = 32 * 5 * qty * r.bed_hole_cost;
    var installSft = W * L / 92903 * qty;
    var installCost = installSft * r.bed_install_sft;
    var liftUpCost = qty * r.bed_liftup_cost;

    var total = cost18 + cost12 + minifixCost + holeCost + installCost + liftUpCost;
    var price = total / (1 - r.margin);
    var sft = (W * L * qty) / 90000;
    return { price: price, sft: sft };
  }

  function calcHanger(r, W, qty) {
    var d = getDerived(r);
    return { price: (W * d.hangerRod * qty) / 1000 / (1 - r.margin) };
  }

  function calcFiller(r, W, H, qty) {
    var d = getDerived(r);
    var priceFactor = calcShutterSftRate(r, d) / (1 - r.margin);
    var sft = (W * H * qty) / 90000;
    var price = sft * priceFactor;
    return { price: price, sft: sft };
  }

  function calcLight(r, W, qty) {
    var d = getDerived(r);
    return { price: (W * qty * d.lighting) / 300 / (1 - r.margin) };
  }

  var ITEM_TYPES = [
    { value: "cabinet", label: "Cabinet" },
    { value: "cabinet_hanging", label: "Cabinet (Wall Hanging)" },
    { value: "cabinet_levellers", label: "Cabinet (Levellers)" },
    { value: "frame", label: "Frame" },
    { value: "shelf", label: "Shelf" },
    { value: "ledge", label: "Ledge" },
    { value: "drawer", label: "Drawer" },
    { value: "tandem", label: "Tandem" },
    { value: "bed", label: "Bed" },
    { value: "hanger", label: "Hanger Rod" },
    { value: "filler", label: "Filler" },
    { value: "visible", label: "Visible Side" },
    { value: "skirting", label: "Skirting" },
    { value: "light", label: "Lighting" },
    { value: "accessory", label: "Accessory" },
  ];

  var SHUTTER_OPTIONS = [
    "Standard", "Profile Shutter", "PU", "Fluted", "Open", "Veneer",
    "Acrylic", "Glass", "Internal", "Rattan Cane", "Paneling", "Fenix",
    "Technomatt", "GM", "Thermo", "Design", "Metallic", "Leather",
    "PP", "Deseo", "Premium", "Mirror", "CNC",
  ];

  function createEmptyItem(id) {
    return { id: id, type: "cabinet", width: "", height: "", depth: "", qty: 1, shutter: "Standard", accessory: "", notes: "" };
  }

  function fmt(n) {
    if (n === 0 || n === "" || isNaN(n)) return "—";
    return "₹" + Math.round(n).toLocaleString("en-IN");
  }

  function calculateItem(item, rates) {
    var W = parseFloat(item.width) || 0;
    var H = parseFloat(item.height) || 0;
    var D = parseFloat(item.depth) || 0;
    var qty = parseFloat(item.qty) || 0;
    if (!qty) return { price: 0, sft: 0 };

    var t = item.type;
    var result = { price: 0, sft: 0 };

    try {
      if (t === "cabinet" || t === "cabinet_hanging" || t === "cabinet_levellers") {
        if (!W || !H || !D) return result;
        var options = { legs: 4, hasSkirting: true };
        if (t === "cabinet_hanging") { options.wallHanging = 1; }
        if (t === "cabinet_levellers") { options.levellers = 4; }
        result = calcCabinet(rates, W, H, D, qty, options);
      } else if (t === "frame") {
        if (!W || !H || !D) return result;
        result = calcFrame(rates, W, H, D, qty);
      } else if (t === "shelf") {
        if (!W || !D) return result;
        result = calcShelf(rates, W, D, qty);
      } else if (t === "ledge") {
        if (!W || !D) return result;
        result = calcLedge(rates, W, D, qty);
      } else if (t === "drawer") {
        if (!W || !H || !D) return result;
        result = calcDrawer(rates, W, H, D, qty);
      } else if (t === "tandem") {
        if (!W || !H || !D) return result;
        result = calcTandem(rates, W, H, D, qty);
      } else if (t === "bed") {
        if (!W || !H || !D) return result;
        result = calcBed(rates, W, H, D, qty);
      } else if (t === "hanger") {
        if (!W) return result;
        result = calcHanger(rates, W, qty);
      } else if (t === "filler" || t === "visible" || t === "skirting") {
        if (!W || !H) return result;
        result = calcFiller(rates, W, H, qty);
        if (t === "visible") result.sft = 0;
      } else if (t === "light") {
        if (!W) return result;
        result = calcLight(rates, W, qty);
      } else if (t === "accessory") {
        var acc = null;
        for (var ai = 0; ai < ACCESSORIES.length; ai++) { if (ACCESSORIES[ai].name === item.accessory) { acc = ACCESSORIES[ai]; break; } }
        if (acc) result = { price: acc.price * qty, sft: 0 };
      }

      var shutterEligible = ["cabinet", "cabinet_hanging", "cabinet_levellers", "frame", "filler", "visible", "skirting"];
      if (item.shutter && item.shutter !== "Standard" && shutterEligible.indexOf(t) !== -1) {
        var delta = getShutterDelta(rates, item.shutter);
        var shutterSft = (W * H * qty) / 90000;
        result.price += shutterSft * delta;
      }
    } catch (e) {
      if (window.console) window.console.error("Furnio estimate calc error:", e);
    }
    return result;
  }

  window.FurnioEngine = {
    DEFAULT_RATES: DEFAULT_RATES,
    SHUTTER_INDEX: SHUTTER_INDEX,
    ACCESSORIES: ACCESSORIES,
    ITEM_TYPES: ITEM_TYPES,
    SHUTTER_OPTIONS: SHUTTER_OPTIONS,
    getShutterDelta: getShutterDelta,
    calcCabinet: calcCabinet,
    calcFrame: calcFrame,
    calcShelf: calcShelf,
    calcLedge: calcLedge,
    calcDrawer: calcDrawer,
    calcTandem: calcTandem,
    calcBed: calcBed,
    calcHanger: calcHanger,
    calcFiller: calcFiller,
    calcLight: calcLight,
    createEmptyItem: createEmptyItem,
    calculateItem: calculateItem,
    fmt: fmt,
  };
})(window);
